import { stringToPastelHsl } from '@src/utils/colors';
import { emailToInitials, equalsIgnoreCase, nameToInitials } from '@src/utils/text-utils';

interface AvatarDisplay {
  initials: string;
  backgroundColor: string;
}

export const authorDisplayLabel = (displayName: string | null | undefined, email: string): string =>
  displayName?.trim() || email;

// Empty-string guard because state.user.email seeds to '' before the /me fetch resolves —
// without it every unauthenticated row would match against a blank authorEmail.
export const isCommentAuthoredBy = (authorEmail: string, currentUserEmail: string): boolean =>
  currentUserEmail.trim().length > 0 && equalsIgnoreCase(authorEmail, currentUserEmail);

// Hash on email (not displayName) so the color stays stable across profile renames.
export const getAuthorAvatar = (
  displayName: string | null | undefined,
  email: string
): AvatarDisplay => {
  const normalizedEmail = email.trim().toLowerCase();
  return {
    initials: nameToInitials(displayName) ?? emailToInitials(normalizedEmail),
    backgroundColor: stringToPastelHsl(normalizedEmail)
  };
};
